import * as yup from 'yup'

export const schemaConfirmSignUp = yup.object().shape({
  password: yup.string().required().min(8),
})
